import Immutable from 'immutable';

const TeamModel = Immutable.Record({
	id: 0,
	name: '',
	description: '',
	accountName: '',
	deviceIds: [],
	urls: [],
	source: 'v3',
	v4Data: null,
});

export default class Team extends TeamModel {
	id: any;
	name: string;
	description: string;
	accountName: string;
	deviceIds: any[];
	urls: Object[];
	source: string;
	v4Data: any;

	get isV4() {
		return this.get('source') === 'v4';
	}

	clone() {
		return this.set('id', this.get('id'));
	}

	filterString() {
		return this.name + this.accountName;
	}

	static create(source = 'v3') {
		return new Team({
			id: 0,
			name: '',
			deviceIds: [],
			urls: [],
			source,
		});
	}
}
